import { render, staticRenderFns } from "./GftSwiperProgressBar.vue?vue&type=template&id=e50c2dd0"
import script from "./GftSwiperProgressBar.vue?vue&type=script&lang=ts"
export * from "./GftSwiperProgressBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports